import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';

import { BaseService } from 'app/_services/base.service';
import { SettingsService } from 'app/_services/settings.service';
import { environment } from '../../../environments/environment';
import { Quotation } from './_models/quotation';
import { UserService } from 'app/_services/user.service';

@Injectable({ providedIn: 'root' })
export class BuyerCreateQuotationService extends BaseService {
    private _apiBuyerUrl: string = `${environment.apiBuyer}`;
    private _domain: string = '/quotations';

    constructor(private userService: UserService, private config: SettingsService) {
        super();
    }

    public convertImageUrlToB64(imagesUrl: string[]): Observable<any> {
        var body = {
            imageUrlList: imagesUrl
        };

        return this.config.executePost({ baseUrl: this._apiBuyerUrl, url: `/images/b64-from-url`, body })
    }

    public createQuotation(quotation: Quotation, isQuotationWithParts: boolean): Observable<any> {
        var body = {
            buyerCompanyId: this.userService.userCompanyId(),
            notes: quotation.notes,
            isOrcamento: quotation.isOrcamento,
            isQuotationWithParts: isQuotationWithParts,
            parts: quotation.parts,
            vehicle: quotation.vehicle,
            pictures: quotation.pictures,
            quotationFile: quotation.quotationFile,
        }

        return this.config.executePost({ baseUrl: this._apiBuyerUrl, url: `${this._domain}`, body })
    }

    public getVehicleByLicensePlate(licensePlate: string): Observable<any> {
        return this.config.executeGet({ baseUrl: this._apiBuyerUrl, url: `${this._domain}/vehicles/${licensePlate}` })
    }

    public uploadQuotationFile(b64file: string | Blob): Observable<any> {
        var formData = new FormData();
        formData.append("b64file", b64file);

        return this.config.executePost({ baseUrl: this._apiBuyerUrl, url: `${this._domain}/from-file/`, body: formData, isJson: false })
    }
}
